export const ADD_BULK_SELECTION = 'ADD_BULK_SELECTION';
export const REMOVE_BULK_SELECTION = 'REMOVE_BULK_SELECTION';
export const RESET_BULK_SELECTION = 'RESET_BULK_SELECTION';
export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER';
export const SET_PROFILE = 'SET_PROFILE';
export const UPDATE_NAVIGATION = 'UPDATE_NAVIGATION';
export const SET_IMPERSONATOR = 'SET_IMPERSONATOR';

// Action Cart
export const SET_ACTION_CART_ITEMS = 'SET_ACTION_CART_ITEMS';
export const ADD_CART_ACTION = 'ADD_CART_ACTION';
export const REMOVE_CART_ACTION = 'REMOVE_CART_ACTION';
export const CLEAR_ACTION_CART = 'CLEAR_ACTION_CART';

// Modify Queue
export const SET_MODIFY_QUEUE = 'SET_MODIFY_QUEUE';
export const ADVANCE_QUEUE = 'ADVANCE_QUEUE';
export const RESET_QUEUE = 'RESET_QUEUE';

// Processed Requests
export const SET_PROCESSED_REQUESTS = 'SET_PROCESSED_REQUESTS';
export const CLEAR_PROCESSED_REQUESTS = 'CLEAR_PROCESSED_REQUESTS';
